import { render } from "./Clause.vue?vue&type=template&id=2bce6815"
import script from "./Clause.vue?vue&type=script&lang=js"
export * from "./Clause.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__